import {Component, Module} from 'app/decorators';

import _ from 'lodash';

import BasePicker from './base.picker';
import ChemicalProgramStore from 'app/stores/chemical.program';

import tpl from './chemical.program.picker.html';


let pintsUnits = ['GAL', 'GALS'];
let convertionGallonsToPints = 8;


@Module({
    name: "app.directives.chemical.program",
    modules: [
        ChemicalProgramStore,
    ]
})
@Component({
    selector: 'blnd-chemical-program-picker',
    bindings: {
        ngModel: '=',
        company: '<',
        customer: '<',
        products: '=',
        acres: '<?',
        ngChanged: '&?',
    },
    template: tpl,
})
export default class C extends BasePicker {
    constructor ($timeout, Config, $element, ChemicalProgramStore, Modal) {
        "ngInject";
        super($element);

        this.internalModel = this.ngModel ? this.ngModel : '';
        this.Modal = Modal;
        this.placeholder = 'Choose Chemical Program';
        this.acres = this.acres || 0;
        this.$timeout = $timeout;
        this.config = Config;

        this.store = ChemicalProgramStore;
        this.store.init();

        this.store.params= {
            company: this.company.id,
            is_active: true
        };
    }

    addProducts () {
        let self = this;
        let params = {
            company: this.company.id,
            extra_field: ['prices',],
        };

        if (this.customer) {
            params.customer = this.customer.id;
            params.price_level = this.customer.price_level;
        }

        this.store.get(this.internalModel.id, params).then(function (response) {
            self.$timeout(function () {
                let applicationRowProduct = _.find(self.products, function (obj) {
                    return obj.product.id == self.config.$config.application_product_id;
                });
                let products = _.map(response.products, (obj) => {
                    let div = (pintsUnits.indexOf(obj.product.units.id) >= 0) ? 8 : 1;
                    let quantity = _.round(self.acres * obj.rate / div, 2);
                    return {
                        product: obj.product,
                        rate_acre: obj.rate,
                        quantity: (_.isNaN(quantity)) ? 0 : quantity,
                    };
                });

                if (applicationRowProduct) {
                    products.push(applicationRowProduct);
                }

                self.products = products;
            })
        })
    }

    onRemove () {
        this.ngModel = angular.copy(this.internalModel);
    }

    confirmModal () {
        this.ngModel = angular.copy(this.internalModel);
        this.addProducts();
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/chemical.program.picker.js